module.exports = __webpack_public_path__ + "assets/img/verdict.1aa3705b.png";